export default {
  title: 'Rail Monsters | Search, Compare and Buy Train Tickets Online',
  description:
    'Rail Monsters - Your one-stop destination to buy wordlwide train tickets online ✓ Save with our discounts ✓ Search & Compare Train Tickets ✓ Get the app for booking',
};
